const changeTabTitle = (title = 'Luciana kyoko | Front-End Developer') => document.title = title;

export default changeTabTitle;